export default (button, userSignedIn) => {
  const buttonBlock = button && button[0]
  if (buttonBlock) {
    const { _uid, component, ...props } = buttonBlock
    if (props.tracking && props.tracking.length === 2 && userSignedIn) {
      props.tracking = [props.tracking[1]]
    } else if (props.tracking) {
      props.tracking = [props.tracking[0]]
    }
    return props
  }
  return null
}
